<template>
<div
  :class="`${darkBg === true ? 'item-selector item-selector--darkbg' : 'item-selector item-selector--lightbg'} rounded-radio-button`"
  @click="checkUncheck"
>
  <img v-if="isChecked && !isMultiple" class="image" src="@assets/images/checked.svg" />
  <img v-if="!isChecked && !isMultiple" class="image" src="@assets/images/unchecked.svg" />
  <img v-if="isMultiple" class="image" src="@assets/images/minus.svg" />
  <span class="text">{{ title }}</span>
</div>
</template>

<script>
export default {
  name: 'base-rounded-radio-button',
  components: {},
  props: {
    title: {
      type: String,
    },
    index: {
      type: Number,
    },
    isChecked: {
      type: Boolean,
    },
    isMultiple: {
      type: Boolean,
    },
    darkBg: {
      type: Boolean,
      default: false,
    },
  },
  data: function() {
    return {};
  },
  methods: {
    checkUncheck: function() {
      this.$emit('roundedRadioCheckUncheck', { checked: !this.isChecked, index: this.index });
    },
  },
  computed: {},
  watch: {},
};
</script>

<style lang="scss" scoped>
@import 'theme.scss';

.item-selector {
  align-items: center;
  border: 1px solid $color-input-border;
  border-radius: $size-input-border-radius;
  cursor: pointer;
  flex: 1 0 auto;
  margin: 0.5rem 0;
  overflow: hidden;
  padding: 0 0.5rem;
  padding-left: 0;
  text-align: left;
  text-overflow: ellipsis;
  white-space: nowrap;
  width: 100%;
  &:disabled {
    background: $color-button-disabled-bg;
    cursor: not-allowed;
  }
  &.rounded-radio-button {
    border-radius: 200px;
  }
  &--lightbg {
    background-color: $color-white;
    border-color: rgba($color-lightGrey, 0.3);
  }
  &--darkbg {
    background-color: $color-white;
    border: 0.1rem solid $color-almostWhite;
  }
  .text {
    color: $color-black;
    flex-grow: 3;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}
</style>
